import { render, staticRenderFns } from "./SettingBoolean.vue?vue&type=template&id=061473d0"
import script from "./SettingBoolean.vue?vue&type=script&lang=ts"
export * from "./SettingBoolean.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports